<template>
  <!-- 休日出勤報告修正 -->
  <div>
    <CCard>
      <CCardHeader>
        <h2>休日出勤報告修正</h2>
      </CCardHeader>
      <CCardBody>
        <span class="asterisk">*</span>
        <span style="margin-bottom: 1rem; display: inline-block">
          が付いている項目は必須入力項目です
        </span>

        <ValidationObserver ref="obs">
          <CRow>
            <div class="container">
              <table class="table table-borderless">

                <!-- 日付 -->
                <tr>
                  <th scope="row">日付<span class="asterisk">*</span></th>
                  <td>
                    <CRow>
                      <CCol sm="6" lg="3">
                        <ValidationProvider name="日付" rules="required" v-slot="ProviderProps">
                          <CInput type="date" v-model="holiday_work_date" />
                          <p class="error">
                            <font color="red">{{ ProviderProps.errors[0] }}</font>
                          </p>
                        </ValidationProvider>
                      </CCol>
                    </CRow>
                  </td>
                </tr>

                <!-- 予定時間 -->
                <tr>
                  <th scope="row">予定時間<span class="asterisk">*</span></th>
                  <td>
                    <CRow>
                      <CCol sm="6" lg="3">
                        <ValidationProvider name="開始予定時間" rules="required" v-slot="ProviderProps">
                          <label>開始予定時間<span class="asterisk">*</span></label>
                          <CInput type="time" v-model="start_time" />
                          <p class="error">
                            <font color="red">{{ ProviderProps.errors[0] }}</font>
                          </p>
                        </ValidationProvider>
                      </CCol>

                      <CCol sm="6" lg="3">
                        <ValidationProvider name="終了予定時間" rules="required" v-slot="ProviderProps">
                          <label>終了予定時間<span class="asterisk">*</span></label>
                          <CInput type="time" v-model="end_time" />
                          <p class="error">
                            <font color="red">{{ ProviderProps.errors[0] }}</font>
                          </p>
                        </ValidationProvider>
                      </CCol>
                    </CRow>
                  </td>
                </tr>

                <!-- 発生理由 -->
                <tr>
                  <th scope="row">発生理由<span class="asterisk">*</span></th>
                  <td>
                    <CRow>
                      <CCol sm="12" lg="6">
                        <ValidationProvider name="発生理由" rules="required" v-slot="ProviderProps">
                          <CInput v-model="reason" />
                          <p class="error">
                            <font color="red">{{ ProviderProps.errors[0] }}</font>
                          </p>
                        </ValidationProvider>
                      </CCol>
                    </CRow>
                  </td>
                </tr>
              </table>
              <CRow class="mt-3 align-items-center">
                <CCol class="text-start">
                  <button class="btn btn-secondary" @click="valueCheck">戻る</button>
                </CCol>
                <CCol class="text-center">
                  <save-button
                    :label="'報告'"
                    :loading="loading"
                    @click="update"
                    class="btn btn-primary"
                  />
                </CCol>
                <CCol></CCol>
              </CRow>
              <label class="mt-2">※ 別途申請処理無く上長が内容を確認します。（申請機能未実装）</label>
            </div>
          </CRow>
        </ValidationObserver>
      </CCardBody>
    </CCard>
  </div>
</template>


<script>
import ConstList from "./../../ConstList";
import axios from "axios";
import SaveButton from '../../common/SaveButton';
export default {
  components: { SaveButton },
  name: "UpdateInput",
  data() {
    return {
      holiday_work_date: "",
      start_time: "",
      end_time: "",
      reason: "",
      // 二重サブミット対処フラグ
      submit_flg: false,
      loading: false,
    };
  },
  // DBから各種情報を取得
  mounted: function () {
    this.id = this.$route.params.id;
    const id = parseInt(this.id);
    axios
      .get(process.env.VUE_APP_API_ORIGIN + "/holidayWork/" + id)
      .then((response) => {
        if (response.data.length === 0) {
          this.errors.push(ConstList.EMPTY);
        }
        const holidayWorkData = response.data;
        this.holiday_work_date = holidayWorkData.date;
        this.start_time = holidayWorkData.start_time;
        this.end_time = holidayWorkData.end_time;
        this.reason = holidayWorkData.reason;
      })
      .catch((error) => {
        axios
        .get(
          `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
        )
        .then(() => {
          alert(ConstList.SYSTEM_ERROR);
        })
        .catch(() => {
          alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
        });
      });
  },
  methods: {
    // 修正情報を送信
    update: function () {
      // 二重サブミット対策
      if (this.submit_flg) return;
      //フラグがfalseならば、フラグをtrueにしたうえでsubmit
      this.submit_flg = true;
      if (confirm) {
        this.loading = true;
        const params = new URLSearchParams();
        params.append("date", this.holiday_work_date);
        params.append("start_time", this.start_time);
        params.append("end_time", this.end_time);
        params.append("reason", this.reason);
        this.id = this.$route.params.id;
        const id = parseInt(this.id);
        axios
          .post(
            process.env.VUE_APP_API_ORIGIN + "/holidayWorkUpdate/" + id,
            params
          )
          .then((response) => {
            this.submit_flg = false;
            if (response.data === ConstList.SUCCESS) {
              alert(ConstList.REGISTER_MESSAGE);
              this.$router.push({ name: "休日出勤報告" });
            } else {
              alert(ConstList.APPLY_ERROR);
            }
          })
          .catch((error) => {
            this.submit_flg = false;
            axios
            .get(
              `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
            )
            .then(() => {
              alert(ConstList.SYSTEM_ERROR);
            })
            .catch(() => {
              alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    valueCheck: function () {
      if ((this.holiday_work_date != 0) || 
        (this.start_time != '') ||
        (this.end_time != '') || 
        (this.reason != '')) {
        if (confirm(ConstList.TRANSITION)) {
          this.$router.push({
            name: ConstList.ROUTE_HOLIDAYWORKS_INFO,
          })
        }
      } else {
        this.$router.push({
          name: ConstList.ROUTE_HOLIDAYWORKS_INFO,
        })
      }
    },
  },
};
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}

.container {
  margin-left: 0%;
}
</style>
